import React from 'react';
export function NavBar() {
  return <nav className="fixed top-[34px] left-0 w-full bg-deep/90 backdrop-blur-lg border-b border-white/5 z-50" data-id="element-95">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-start items-center" data-id="element-96">
        <div className="text-white font-bold text-xl tracking-wide" data-id="element-97">
          BioClock™
        </div>
      </div>
    </nav>;
}